<template>
  <section class="sidebar">
    <section class="fullScreen" id="sidebar">
      <!-- ============================== Big Screen Sidebar -->
      <v-navigation-drawer
        class="main_sidebar"
        :class="mainNavOpen ? 'active' : ''"
        permanent
        :expand-on-hover="false"
        ref="mainSidebar"
      >
        <!-- Upper Scection -->
        <div class="top_logo">
          <!-- change sidebar -->
          <span @click.stop="toggleMainMenu" class="toggleMainMenue">
            <i class="fa fa-bars"></i>
          </span>
          <!-- change sidebar -->
          <div class="logo">
            <h2>{{ $t("dashName") }}</h2>
          </div>
          <!-- <div class="toggleResize">
          <button
            @click="toggleSideBarFullWidth"
            class="btn ful-w"
            :class="{ ful_back: menueMinWidth }"
          ></button>
        </div> -->
        </div>

        <!-- <v-divider></v-divider> -->

        <v-list>
          <template>
            <v-list-item
              to="/profile/edit"
              class="p-2 porfile-rap"
              v-if="userDataExist"
            >
              <div class="d-flex align-items-center gap-3">
                <div
                  class="img-raper rounded-circle d-flex align-items-center justify-content-center"
                  style="width: 50px; height: 50px; overflow: hidden"
                >
                  <img
                    class=""
                    style="/* object-fit: cover; */ width: 100%; height: 100%"
                    :src="userDataExist.image"
                  />
                </div>
                <div class="text">
                  <h3>{{ userDataExist.fullname }}</h3>
                </div>
              </div>
            </v-list-item>
            <v-list-item to="/">
              <v-icon>fas fa-home</v-icon>
              <v-list-item-title>{{ $t("navs.home") }}</v-list-item-title>
            </v-list-item>
          </template>
          <template v-for="item in sidebar">
            <div
              class="divider_new"
              v-if="
                item.label &&
                item.categories[0].key == 'general' &&
                !$permission.allowed(item.categories[0]?.permissions[0]?.url)
              "
              :key="item.id"
            >
              <span>{{ item.label }}</span>
            </div>
            <div
              class="divider_new"
              v-else-if="
                (item.label &&
                  item.categories[0].permissions.length > 1 &&
                  !$permission.allowed(
                    item.categories[0]?.permissions[0]?.url
                  )) ||
                (item.label &&
                  item.categories[0].permissions.length > 1 &&
                  !$permission.allowed(item.categories[0]?.permissions[1]?.url))
              "
              :key="item.id"
            >
              <span>{{ item.label }}</span>
            </div>

            <template v-for="sub_item in item.categories">
              <v-list-item
                v-if="
                  sub_item.key == 'general' &&
                  !$permission.allowed(`${sub_item.permissions[0].url}`)
                "
                :key="sub_item.id"
                :to="`/${sub_item.permissions[0].url}`"
              >
                <v-icon>{{ sub_item.icon }}</v-icon>
                <v-list-item-title>{{ sub_item.title }} </v-list-item-title>
              </v-list-item>
              <!-- If DropDown -->
              <v-list-group
                :key="sub_item.uuid"
                v-else-if="
                  !$permission.allowed(`${sub_item.permissions[0].url}`) ||
                  !$permission.allowed(`${sub_item.permissions[1]?.url}`)
                "
                :class="{
                  activeDropDown: sub_item.active,
                }"
                class="parnet"
                v-model="sub_item.active"
                :prepend-icon="sub_item.icon"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ sub_item.title }} </v-list-item-title>
                  </v-list-item-content>
                </template>

                <div v-for="child in sub_item.permissions" :key="child.id">
                  <v-list-item
                    :to="`/${child.url}`"
                    v-if="!$permission.allowed(`${child.url}`)"
                  >
                    <v-list-item-content>
                      <!-- <span class="polit"></span> -->
                      <v-list-item-title>{{ child.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </v-list-group>
            </template>
          </template>
        </v-list>
      </v-navigation-drawer>
      <!-- ============================== Small Screen Sidebar -->
    </section>
    <aside class="smallScreenSidebar main_sidebar" ref="smallSidebar">
      <span @click.stop="toggleMenu" class="close">
        <i class="fas fa-times"></i>
      </span>

      <!-- Upper Scection -->
      <div class="top_logo">
        <div class="logo">
          <router-link to="/">
            <div style="width: 50px; height: 50px">
              <img
                class="img-fluid"
                style="width: 100%"
                v-if="current_theme == 'light'"
                src="@/assets/media/images/logo/logo4.png"
              />
              <img
                style="width: 100%"
                class="img-fluid"
                v-else
                src="@/assets/media/images/logo/logo4.png"
              />
            </div>
          </router-link>
        </div>
      </div>
      <v-list>
        <v-list-item to="/profile/edit" class="p-2 porfile-rap">
          <div class="d-flex align-items-center gap-3">
            <div
              class="img-raper rounded-circle d-flex align-items-center justify-content-center"
              style="width: 50px; height: 50px; overflow: hidden"
            >
              <img
                class=""
                style="/* object-fit: cover; */ width: 100%; height: 100%"
                :src="userDataExist.image"
              />
            </div>
            <div class="text">
              <h3>{{ userDataExist.fullname }}</h3>
            </div>
          </div>
        </v-list-item>
        <v-list-item to="/">
          <v-icon>fas fa-home</v-icon>
          <v-list-item-title>{{ $t("navs.home") }}</v-list-item-title>
        </v-list-item>

        <template v-for="item in sidebar">
          <div
            class="divider_new"
            v-if="
              item.label &&
              item.categories[0].key == 'general' &&
              !$permission.allowed(item.categories[0]?.permissions[0]?.url)
            "
            :key="item.id"
          >
            <span>{{ item.label }}</span>
          </div>
          <div
            class="divider_new"
            v-else-if="
              (item.label &&
                item.categories[0].permissions.length > 1 &&
                !$permission.allowed(
                  item.categories[0]?.permissions[0]?.url
                )) ||
              (item.label &&
                item.categories[0].permissions.length > 1 &&
                !$permission.allowed(item.categories[0]?.permissions[1]?.url))
            "
            :key="item.id"
          >
            <span>{{ item.label }}</span>
          </div>
          <template v-for="sub_item in item.categories">
            <v-list-item
              v-if="
                sub_item.key == 'general' &&
                !$permission.allowed(`${sub_item.permissions[0].url}`)
              "
              :key="sub_item.id"
              :to="`/${sub_item.permissions[0].url}`"
            >
              <v-icon>{{ sub_item.icon }}</v-icon>
              <v-list-item-title>{{ sub_item.title }}</v-list-item-title>
            </v-list-item>
            <!-- If DropDown -->
            <v-list-group
              v-else-if="
                !$permission.allowed(`${sub_item.permissions[0].url}`) ||
                !$permission.allowed(`${sub_item.permissions[1]?.url}`)
              "
              :key="sub_item.uuid"
              :class="{
                activeDropDown: sub_item.active,
              }"
              class="parnet"
              v-model="sub_item.active"
              :prepend-icon="sub_item.icon"
              @click.stop
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ sub_item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <template>
                <div v-for="child in sub_item.permissions" :key="child.id">
                  <v-list-item
                    v-if="!$permission.allowed(`${child.url}`)"
                    :to="`/${child.url}`"
                  >
                    <v-list-item-content>
                      <!-- <span class="polit"></span> -->
                      <v-list-item-title>{{ child.title }}</v-list-item-title>
                      <!-- <v-list-item-title>ZOSAR</v-list-item-title> -->
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </template>
            </v-list-group>
          </template>
        </template>
      </v-list>
      <ul class="navIcons" v-if="false">
        <!-- Theme -->
        <li v-if="current_theme == 'dark'" @click="changeTheme('light')">
          <i class="fal fa-sun"></i>
        </li>
        <li v-if="current_theme == 'light'" @click="changeTheme('dark')">
          <i class="fal fa-moon"></i>
        </li>

        <!-- Lang -->
        <li v-if="lang == 'ar'" @click="changeLang('en')">
          <i class="fal fa-globe"></i>
        </li>
        <li v-if="lang == 'en'" @click="changeLang('ar')">
          <i class="fal fa-globe"></i>
        </li>
      </ul>
    </aside>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      menueMinWidth: true,
      sidebar: [],
      mainNavOpen: true,
      userDataExist: false,
    };
  },

  methods: {
    toggleSideBarFullWidth() {
      this.menueMinWidth = !this.menueMinWidth;
      this.$store.dispatch("sideNav_module/onResize");
    },

    toggleMenu() {
      this.$refs.smallSidebar.classList.toggle("active");
    },

    toggleMainMenu() {
      this.mainNavOpen = !this.mainNavOpen;
      const mainNav = document.querySelector(".main_nav");
      mainNav.classList.toggle("active");
      const mainWrapper = document.querySelector(".app-wrapper");
      mainWrapper.classList.toggle("active");
    },

    changeTheme(value) {
      this.$store.dispatch("theme_module/changeTheme", value);
      if (value == "light") {
        this.$vuetify.theme.dark = false;
      } else {
        this.$vuetify.theme.dark = true;
      }
      this.$refs.smallSidebar.classList.remove("active");
    },

    changeLang(value) {
      this.$store.dispatch("lang_module/switchLang", value);
      this.$refs.smallSidebar.classList.remove("active");
    },
    manipulateTheSideBarComplete() {
      // Convert 'JSON' Object to JS Object
      const Json_Sidebar = JSON.parse(JSON.stringify(this.$t("sidebar")));
      Json_Sidebar.forEach((el) => {
        // IF Dropdown
        if (el.items) {
          // ======== Check Nested
          let inside_nested = false;
          el.items.forEach((element) => {
            if (element.items) {
              inside_nested = true;
            }
          });

          // ======== IF Nested Else
          if (inside_nested) {
            el.items.forEach((subEl) => {
              // Active
              subEl.activeRoutesMatch = subEl.items[0].url;

              // DropDown
              if (this.$route.path.includes(subEl.activeRoutesMatch)) {
                subEl.active = true;
              } else {
                subEl.active = false;
              }
            });
            el.activeRoutesMatch = el.parentUrl;

            // DropDown
            if (this.$route.path.includes(el.activeRoutesMatch)) {
              el.active = true;
            } else {
              el.active = false;
            }
          } else {
            el.activeRoutesMatch = el.items[0].url;

            // DropDown
            if (this.$route.path.includes(el.activeRoutesMatch)) {
              el.active = true;
            } else {
              el.active = false;
            }
          }
        }
      });
      this.sidebar = Json_Sidebar;
    },

    manipulateTheSideBar() {
      let Json_Sidebar = JSON.parse(JSON.stringify(this.$t("sidebar")));

      this.axios.get("account/permissions").then((res) => {
        localStorage.setItem(
          "m7_dash_permissions",
          JSON.stringify(res.data.data)
        );

        // let currUserPermissions = [];
        // res.data.data.map((item) => {
        //   currUserPermissions.push(item.url);
        // });

        // let currentSidebar = [];

        // Json_Sidebar.map((item) => {
        //   item.categories.map((category) => {
        //     category.permissions.map((permission) => {
        //       if (currUserPermissions.includes(permission.url)) {
        //         if (!currentSidebar.find((el) => el.label == item.label)) {
        //           currentSidebar.push(item);
        //         }
        //       }
        //     });
        //   });
        // });
        // Json_Sidebar = currentSidebar;
        Json_Sidebar.forEach((el) => {
          // IF Dropdown
          if (el.items) {
            // ======== Check Nested
            let inside_nested = false;
            el.items.forEach((element) => {
              if (element.items) {
                inside_nested = true;
              }
            });

            // ======== IF Nested Else
            if (inside_nested) {
              el.items.forEach((subEl) => {
                // Active
                subEl.activeRoutesMatch = subEl.items[0].url;

                // DropDown
                if (this.$route.path.includes(subEl.activeRoutesMatch)) {
                  subEl.active = true;
                } else {
                  subEl.active = false;
                }
              });
              el.activeRoutesMatch = el.parentUrl;

              // DropDown
              if (this.$route.path.includes(el.activeRoutesMatch)) {
                el.active = true;
              } else {
                el.active = false;
              }
            } else {
              el.activeRoutesMatch = el.items[0].url;

              // DropDown
              if (this.$route.path.includes(el.activeRoutesMatch)) {
                el.active = true;
              } else {
                el.active = false;
              }
            }
          }
        });

        this.sidebar = Json_Sidebar;
      });
      // const userPermission = JSON.parse(
      //   localStorage.getItem("m7_dash_permissions")
      // );
    },
    getUserData() {
      this.axios.get("account").then((data) => {
        this.userDataExist = data.data.data;
      });
    },
    getSideBar() {
      this.axios.get("side-bar-permissions").then((res) => {
        this.sidebar = res.data.data;
      });
    },
  },

  computed: {
    ...mapGetters({
      current_theme: "theme_module/current_theme",
      lang: "lang_module/lang",
      user: "auth_module/currentUser",
    }),
  },

  async created() {
    this.getUserData();

    this.control = this.$permission.setControls(this.$route.path);
    if (this.user.usertype == "superadmin") {
      this.manipulateTheSideBarComplete();
    } else {
      // this.getSideBar();
      // await this.getPermissions();
      this.manipulateTheSideBar();
    }
  },
};
</script>

<style lang="scss"></style>
